<template lang="pug">
  .component-update-driver-reservation-requests
    .dropdown-buttons
      //GroupReveal(:groupProp="item", @refresh="$emit('refresh')")
      ModalReveal(:ref="modal")
        a(slot="trigger", @click="search") Update status
        .row
          .column
            Driver(:item="item.driver", type="driver-card" )
          .column
            .row
              .column
                label Dates
                div From: {{$dateFormat(item.start, 'DD MMM YYYY HH:mm')}} - {{item.pick_up.name}}
                div To: {{$dateFormat(item.end, 'DD MMM YYYY HH:mm')}}  - {{item.drop_off.name}}
            .row

              .column
                .label Passengers
                .value {{item.flags.passengers}}
              .column
                label Offroad
                span.fa(:class='{"offroad": item.flags.offroad ,"fa-times":!item.flags.offroad,"fa-check":item.flags.offroad} ')
            .row
              .column
                label Notes
                .field-value {{item.notes}}
        .row
          .column
            h2 Select status
            select(v-model="body.status" )
              option NEW
              option WAITING
              option ACCEPTED
              option REJECTED

            ActionButton(:action="updateStatus") Update

</template>

<script>
import PolicyReveal from '../../../../pages/backoffice/PolicyReveal'
import ModalReveal from '../../foundation/ModalReveal'
import ActionButton from '../ActionButton'
import GroupReveal from '../../../../pages/backoffice/GroupEdit'
import Driver from "../../../backoffice/Driver.vue";
import SelectizeParkingLot from "../lists/selectize/SelectizeParkingLot.vue";
import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";
import collect from "collect.js";
import Vehicle from 'components/backoffice/Vehicle'
import MaggieHelper from "../../../../maggieHelper";
import {EventBus} from "src/eventBus";

export default {
  name: 'UpdateDriverReservationRequestStatus',
  components: {Vehicle, SelectizeParkingLot, Driver, GroupReveal, PolicyReveal, ActionButton, ModalReveal},
  data() {
    return {
      slots: [],
      loading: false,
      body: {
        status: null
      }
    }
  },
  created() {
  },
  methods: {
    collect,
    search() {
      this.loading = true

    },
    updateStatus() {
      return KeplerBackofficeSdk.reservations.updateStatusRequest(this.item.id, {status: this.body.status}, (response) => {
        MaggieHelper.notification('Driver reservation request', 'Request updated')
        EventBus.$emit('reload-list')
        this.$refs[this.modal].close()

      })
    },

    bookNow(vehicle) {
      KeplerBackofficeSdk.reservations.makeDriverRequestBooking(this.item.id, {plate: vehicle.plate}, (response) => {
        MaggieHelper.notification('book-esit', 'reservation created')
        this.$refs[this.modal].close()
        this.$router.push({name: 'reservation', params: {id: response.id}})

      })
    },
  },
  computed: {
    modal() {
      return `modal-${this._uid}`
    },

  },
  props: ['item', 'driver']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UpdateDriverReservationRequestStatus.vue?5e0a5196